export const surveySelector = state => state.survey;
